function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawScience = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 987.62 787.4",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 903.3,
    y1: 782.16,
    x2: 903.3,
    y2: 259.8,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("path", {
    d: "M59.04 745.07s-42.27-2.55-37.29 27.08c0 0-1 5.23 3.75 7.61 0 0 .08-2.2 4.34-1.45a19.36 19.36 0 0 0 4.59.22 9.57 9.57 0 0 0 5.62-2.32s11.88-4.91 16.51-24.33c0 0 3.42-4.24 3.28-5.33l-7.13 3s2.43 5.15.52 9.42c0 0-.24-9.23-1.61-9-.28.05-3.7 1.79-3.7 1.79s4.19 9 1 15.48c0 0 1.2-11.05-2.34-14.84l-5 2.94s4.91 9.26 1.58 16.81c0 0 .85-11.59-2.63-16.1l-4.55 3.55s4.6 9.13 1.79 15.39c0 0-.36-13.49-2.78-14.51 0 0-4 3.51-4.59 5 0 0 3.16 6.62 1.2 10.12 0 0-1.2-9-2.18-9 0 0-4 5.95-4.38 10 0 0 .17-6.08 3.41-10.61a11.89 11.89 0 0 0-6.07 3.14s.62-4.21 7.05-4.58c0 0 3.28-4.51 4.16-4.79 0 0-6.4-.53-10.28 1.19 0 0 3.41-4 11.45-2.17l4.5-3.67s-8.43-1.15-12 .12c0 0 4.11-3.51 13.21-.95l4.89-2.92s-7.19-1.55-11.47-1c0 0 4.52-2.44 12.9.2l3.5-1.57s-5.27-1-6.81-1.2-1.62-.59-1.62-.59a18.26 18.26 0 0 1 9.89 1.1s7.42-2.76 7.29-3.23z",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 29.92,
    cy: 782.34,
    rx: 29.92,
    ry: 5.06,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M987.17 677.78s-23.84-1.44-21 15.26a4.08 4.08 0 0 0 2.12 4.3s0-1.24 2.44-.82a11.15 11.15 0 0 0 2.59.12 5.39 5.39 0 0 0 3.17-1.3s6.7-2.77 9.31-13.72c0 0 1.92-2.39 1.85-3l-4 1.72s1.37 2.9.29 5.32c0 0-.13-5.21-.9-5.09-.16 0-2.1 1-2.1 1s2.37 5 .59 8.72c0 0 .67-6.22-1.32-8.36l-2.84 1.65s2.77 5.23.89 9.49c0 0 .49-6.54-1.48-9.08l-2.57 2s2.6 5.14 1 8.68c0 0-.21-7.61-1.57-8.18a15.64 15.64 0 0 0-2.59 2.79s1.78 3.73.68 5.71c0 0-.68-5.07-1.24-5.09 0 0-2.23 3.35-2.46 5.65a12.18 12.18 0 0 1 1.92-6 6.69 6.69 0 0 0-3.42 1.78s.35-2.38 4-2.59c0 0 1.85-2.54 2.35-2.7 0 0-3.61-.3-5.8.67 0 0 1.93-2.24 6.46-1.22l2.53-2.07s-4.75-.65-6.76.07c0 0 2.32-2 7.44-.54l2.76-1.65a24.87 24.87 0 0 0-6.46-.55s2.54-1.38 7.27.11l2-.89s-3-.58-3.83-.67-.92-.33-.92-.33a10.32 10.32 0 0 1 5.58.62s4.09-1.55 4.02-1.81z",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 970.75,
    cy: 698.79,
    rx: 16.87,
    ry: 2.85,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M938.15 723.25s-28.78-1.73-25.34 18.45a4.93 4.93 0 0 0 2.56 5.19s0-1.5 3-1a13.14 13.14 0 0 0 3.13.15 6.52 6.52 0 0 0 3.82-1.58s8.09-3.34 11.23-16.56c0 0 2.33-2.89 2.24-3.63l-4.86 2.08s1.66 3.5.36 6.41c0 0-.16-6.29-1.09-6.14-.19 0-2.53 1.21-2.53 1.21s2.86 6.11.7 10.54c0 0 .82-7.52-1.59-10.09l-3.42 2s3.34 6.31 1.08 11.45c0 0 .58-7.89-1.8-11l-3.09 2.41s3.13 6.22 1.22 10.48c0 0-.25-9.18-1.9-9.87 0 0-2.71 2.38-3.12 3.37 0 0 2.15 4.51.82 6.89 0 0-.82-6.12-1.49-6.15 0 0-2.7 4.05-3 6.83a14.77 14.77 0 0 1 2.33-7.22 8.15 8.15 0 0 0-4.14 2.14s.42-2.86 4.8-3.11c0 0 2.23-3.08 2.83-3.27 0 0-4.36-.36-7 .81 0 0 2.33-2.7 7.8-1.47l3.06-2.5s-5.74-.79-8.17.08c0 0 2.8-2.39 9-.65l3.33-2s-4.89-1.05-7.8-.67c0 0 3.07-1.66 8.78.14l2.38-1.07s-3.59-.71-4.63-.82-1.11-.4-1.11-.4a12.43 12.43 0 0 1 6.73.75s4.96-1.86 4.88-2.18z",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 918.32,
    cy: 748.62,
    rx: 20.37,
    ry: 3.44,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 805.49,
    cy: 726.42,
    rx: 92.33,
    ry: 14.41,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 513.32,
    cy: 767.92,
    rx: 103.75,
    ry: 10.41,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 198.99,
    cy: 763.13,
    rx: 78.75,
    ry: 4.86,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M338.81 34.25c29.21-26 75.07-31.33 116.8-29.26 131.09 6.51 249.42 69.8 351.78 141.39 37.06 25.91 73.54 53.84 97.59 89.53 49 72.64 34.44 173.28-33.64 233.13-23.17 20.36-51.25 36-80.08 49.81-51.26 24.61-106.57 44.36-164.74 50-41.49 4-83.49.75-124.73-4.85-115.24-15.64-228.35-50.2-323.15-109.3-41.58-26-80.78-58.2-97.92-100.15s-6.17-95.11 36.29-119.94c17.56-10.27 38.56-14.91 59.11-19.26 30.26-6.41 61-12.73 88.31-25.77 28.2-13.46 61.59-39.49 56-69.28-5.98-31.97-10.79-60.05 18.38-86.05z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M580.86 391.78V200.84h26v-57h-186.3v57h26v190.94a189.38 189.38 0 0 0-122.14 177c0 104.55 84.76 189.3 189.31 189.3s189.3-84.75 189.3-189.3a189.37 189.37 0 0 0-122.17-177z",
    fill: "#96b7fe",
    opacity: 0.9
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M446.52 200.25h134.34v2.57H446.52z"
  }), React.createElement("path", {
    d: "M407.81 563.7s114-2 171-30.53 89.57-3.06 86.51 14.25-19.33 50.88-84.47 55-173.04-38.72-173.04-38.72z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M407.81 563.7s114-2 171-30.53 89.57-3.06 86.51 14.25-19.33 50.88-84.47 55-173.04-38.72-173.04-38.72z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M358.99 545.4s-12.18 168.95 147.57 172 158.77-170 158.77-170-59 64.11-198.46 11.19c0 .04-72.26-19.3-107.88-13.19z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M664.81 548.01c-3.19 38.92-23.88 160.75-158.19 158.18-131.66-2.49-146.57-117.59-147.74-158.08-.73 21.73-.08 166.45 147.71 169.28 159.79 3 158.77-170 158.77-170s-.2.25-.55.62z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 507.53,
    cy: 472.5,
    r: 20.73,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 519.37,
    cy: 389.57,
    r: 12.83,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 490.74,
    cy: 315.52,
    r: 12.83,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    d: "M380.81 488.49c-1.1 8.74-.88 19.68 6.93 23.76-6.55-3.42 20.3-42.2 16.49-50.12-8.15-16.9-22.42 18.24-23.42 26.36z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("circle", {
    cx: 480.37,
    cy: 85.01,
    r: 20.73,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 542.56,
    cy: 49.47,
    r: 15.41,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 498.14,
    cy: 8.01,
    r: 8.01,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    d: "M283.81 263.18H116.28v49.69h25.53v387.66a58.25 58.25 0 1 0 116.49 0V312.87h25.51z",
    fill: "#96b7fe",
    opacity: 0.9
  }), React.createElement("path", {
    d: "M180.62 400.7s41.46-14.81 53-4.28c0 0-16.79 24.68-32.25 23.69s-20.75-19.41-20.75-19.41z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M180.62 400.7s41.46-14.81 53-4.28c0 0-16.79 24.68-32.25 23.69s-20.75-19.41-20.75-19.41z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M233.6 396.46v281.36a35.54 35.54 0 0 1-35.54 35.54 35.54 35.54 0 0 1-35.54-35.54V396.46s17.11-4.61 33.23 5.27 37.85-5.27 37.85-5.27z",
    fill: primaryColor
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M141.79 312.56h116.49v2.29H141.79zM198.06 696.25a35.54 35.54 0 0 1-35.54-35.55v17.77a35.54 35.54 0 0 0 35.54 35.54 35.54 35.54 0 0 0 35.54-35.54V660.7a35.54 35.54 0 0 1-35.54 35.55z"
  }), React.createElement("circle", {
    cx: 198.07,
    cy: 361.59,
    r: 7.24,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 221.76,
    cy: 335.92,
    r: 4.61,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 189.51,
    cy: 326.71,
    r: 4.61,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    d: "M150.81 453.94c-1.1 8.74-.88 19.68 6.93 23.76-6.56-3.42 20.3-42.19 16.49-50.12-8.17-16.88-22.42 18.25-23.42 26.36z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("circle", {
    cx: 213.09,
    cy: 214.5,
    r: 17.59,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 160.32,
    cy: 184.34,
    r: 13.08,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 198.01,
    cy: 149.16,
    r: 6.8,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    d: "M1002.05 507.62s-15.35-76.34-9.48-85.84c0 0 .21-8.83-.14-20.08v-1.3a26.53 26.53 0 0 0 3.22 1.88 26 26 0 0 0 17.57 2.27l-4.67-5.18c-1.11-1.24-2.28-2.57-2.52-4.21a9.17 9.17 0 0 1 1-4.55c4.41-11.15 4.68-25.18-3.86-33.69-7.18-7.16-8.94-16.4-16.7-22.93-5.7-4.79-8.83-11.81-11.79-18.58-2.5-5.74-5-11.52-6.45-17.6-1.12-4.75-1.56-9.66-3.1-14.3s-4.4-9.15-8.89-11.22a32.66 32.66 0 0 1-4.83-2.14c-1.92-1.29-3.07-3.39-4.45-5.22-7-9.31-30.6-3.83-41.76-.05a23.51 23.51 0 0 0-8.25 4.57l.1-.17.28-.41a14.78 14.78 0 0 0-3.12 3.48c-1.63 2.58-2.31 5.61-3.66 8.33-1.64 3.3-10.74 12.51-6.83 16.22a3.35 3.35 0 0 0 .91.6 8.15 8.15 0 0 0 4.61.46c-.06.13-.12.26-.17.39a27.26 27.26 0 0 0-2 10.31 27.9 27.9 0 0 0 28.14 27.65 28.52 28.52 0 0 0 8.62-1.32c.07.35.13.7.19 1.05 0 .15 0 .29.07.43l-.49.69-.08-.13-14.59 20.4c-2.23 1.56-15.08 10.86-15.77 17.83-.76 7.63-1.52 16.57-1.52 16.57l-.1 1.91a5.76 5.76 0 0 1-4.64 1.26c-4.55-.75-4.55 16.76-4.55 16.76s-3 2.79-5.11.37-7.58 5.77-7.58 5.77l-34.49 1.49h-.79l-1.86-5.76a2.43 2.43 0 0 0-3-1.54 1.94 1.94 0 0 0-.42.17l-.12.08a1.46 1.46 0 0 0-.24.17.69.69 0 0 0-.13.11 1.7 1.7 0 0 0-.19.19 1.47 1.47 0 0 0-.1.13l-.06.06a2.35 2.35 0 0 0-.34 2.08l1.6 4.94c-6.65 1.34-13.46 5.11-7.91 15.51l-28.12-5.19 9.1 7.63 47 9.7c-.62 1.12-.21 2.73 1.73 5 8.35 9.82 23.61 12.48 29.74 13.18a52.59 52.59 0 0 0 6 10.19l-.54 9.78S871 560.41 868.15 564.2A44.23 44.23 0 0 0 872 559c-4.51 15.33-10.81 36.31-12.46 39.45-2.66 5-5.12 25.32-2.09 26.63.95.4 3.58.21 7.37-.08v1.68l-.17 63.75s.76 39.11-1.33 42.83-2.65 11.54-2.65 11.54-8.38 15.43-15 21.63l-.15.13-.21-1.46s-8 10.06-25.58 9.5c0 0-10.61 6.89 5.12 7.26s35.81-.56 35.81-.56 14-21.41 25.77-18.62v16.2h3.6v-16.34a14.76 14.76 0 0 0 6.4-9.71 11.75 11.75 0 0 0-4.19-10.89 7 7 0 0 1-2.3-5.1l-.13.11c0-.32-.08-.65-.13-1-1-8.38-2.31-25.62 2.25-38.4 6.25-17.51 8.15-41.89 3.6-56.42a129.1 129.1 0 0 1-3.6-14.13c-.11-.61-.22-1.18-.31-1.72a71 71 0 0 1 9.23 1.89c10.56 2.9 33.63 3.44 53.33 3.29.05.54.11 1.1.17 1.67a60.66 60.66 0 0 0 2.22 11.6c2.46 7.46 3.6 40.22 3.6 40.22s3.19 26.95 1.45 37.93c-1 6.1-1.84 12.22-2.39 18.37v.12s-5.22 14.89-9 23c-.1.21-.19.41-.29.61a12.6 12.6 0 0 0-3 .65s-5.11 10.24-10.23 11.92-3.41 7.26 8.15 5.21 29-3.72 29-3.72l.76-10.43 3.55-4.44-.9 10.4 3.79-.74-.5-12.66 5.81-7.27s7-6.24-3.41-18.52v.26c-.11-.18-.22-.36-.34-.53v-.06c-1.72-2.68-3.1-7.67-.58-16.53 4.55-16 7.2-30.53 7.2-30.53s10.17-38.91-2.06-57.33h.55a31.08 31.08 0 0 1-2.64-8.18c-.06-.34-.11-.69-.17-1 9-.52 17.93-2.16 25.16-5.68-.08-.11-4.43-92.47-8.03-107.18zm-114.83-64.4v.18l-1.87.09zm-6.37.88a2 2 0 0 0-.84.4 8.31 8.31 0 0 0-1.46 3.82l-2.9-.66s-2-.43-5-.91l-1.39-1.39c3.86-.36 7.82-.79 11.59-1.26z",
    transform: "translate(-106.19 -56.3)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    fill: "#1d2366",
    d: "M870.61 703.96l-1.11 13.18 3.71-.75-.56-14.28-2.04 1.85z"
  }), React.createElement("path", {
    d: "M786 641.43c-4.47 12.73-3.19 29.92-2.19 38.27.37 3.09.71 5 .71 5s-6.68 15.22-7.24 15.78-19.68 12.22-19.68 12.22l-13.36 7.79s-13.55-5.94-7-8a9.87 9.87 0 0 0 3.5-2.39c6.48-6.18 14.69-21.55 14.69-21.55s.55-7.79 2.59-11.5 1.3-42.68 1.3-42.68l.17-63.54v-8.28l25.42.19a58.33 58.33 0 0 0 1.1 8.37 129.44 129.44 0 0 0 3.54 14.08c4.42 14.51 2.57 38.79-3.55 56.24z",
    fill: "#ffb0b1"
  }), React.createElement("path", {
    d: "M784.51 684.7s-6.68 15.22-7.24 15.78-19.67 12.22-19.67 12.22l-13.36 7.79s-13.55-5.94-7-8a9.87 9.87 0 0 0 3.5-2.39l.58 4.06 4.46-.19 38.03-34.27c.36 3.08.7 5 .7 5z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M784.05 680.58l-38.32 34.52-4.46.18-.92-6.49s-7.8 10-25.06 9.46c0 0-10.39 6.87 5 7.24s35.08-.56 35.08-.56 13.73-21.34 25.23-18.55v16.14h3.53v-16.33a14.67 14.67 0 0 0 6.26-9.67 11.83 11.83 0 0 0-4.1-10.86 7 7 0 0 1-2.24-5.08z",
    fill: "#1d2366"
  }), React.createElement("path", {
    d: "M874.14 661.28c-2.47 8.83-1.12 13.8.56 16.47v.06a30.42 30.42 0 0 1 4.47 10.89l.16.84-17.44 25.42-9.46 3.71s-15.22-5.19-12.44-6.68c.7-.37 1.79-2.29 3-5 3.73-8 8.85-22.86 8.85-22.86V684c.53-6.13 1.39-12.23 2.34-18.31 1.7-10.93-1.42-37.79-1.42-37.79s-1.11-32.65-3.53-40.08a62 62 0 0 1-2.17-11.56c-.5-4.67-.61-8.48-.61-8.48s10-13.92 28.39 1.11a20.54 20.54 0 0 1 3.83 4.17c12.69 18 2.48 57.81 2.48 57.81s-2.56 14.46-7.01 30.41z",
    fill: "#ffb0b1"
  }), React.createElement("path", {
    d: "M879.33 689.49l-17.44 25.42-9.46 3.71s-15.22-5.19-12.44-6.68c.7-.37 1.79-2.29 3-5 6.44 0 9.78 6.08 9.78 6.08l8.16-1.29s10.77-21.16 13.18-22.45.37-9.66.37-9.66v-2.13l.19.23v.06a30.42 30.42 0 0 1 4.5 10.92z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M853.35 713.61s-4.64-8.53-13.54-5.38c0 0-5 10.21-10 11.88s-3.34 7.23 8 5.19 28.39-3.71 28.39-3.71l.74-10.39 11.5-14.66s6.87-6.22-3.34-18.46v2.13s2 8.35-.37 9.65-13.17 22.45-13.17 22.45z",
    fill: "#1d2366"
  }), React.createElement("path", {
    d: "M784.88 562.75a58.33 58.33 0 0 0 1.1 8.37c-10.47-1.54-20.18-.77-26.54-.28v-8.28zM879.7 575.37s-14.88.72-32.6.87c-.5-4.67-.61-8.48-.61-8.48s10-13.92 28.39 1.11a20.54 20.54 0 0 1 3.83 4.17 24.42 24.42 0 0 0 .99 2.33z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M879.7 573.7s-65.13 3.15-85-2.41-39.52-.75-42.49-2.05-.55-21.52 2-26.53 16.89-55.67 16.89-55.67l13.73-71.63 14.48-4 1-.28 25.21-7 18.49-5.1s36.74 143.44 33.58 154a27 27 0 0 0-.53 12.45 31.19 31.19 0 0 0 2.64 8.22z",
    fill: "#1d2366"
  }), React.createElement("path", {
    d: "M737.01 366.42s-13 13.92-3.16 21.71 16.33.75 16.33.75z",
    fill: "#c7daf5"
  }), React.createElement("path", {
    d: "M737.01 366.42s-13 13.92-3.16 21.71 16.33.75 16.33.75z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M842.13 274.76s-1.52 1.44-3.82 3.59c-3.27 3.05-8.11 7.52-12.41 11.27-6 5.18-10.85 9-9.1 5.73s1.42-8.89.55-14.18l-.18-1.05a97.29 97.29 0 0 0-2.88-11.49s9.61-12.42 14.93-17.32c2-1.83 3.37-2.61 3.44-1.33.1 1.74 1.41 5.54 3 9.66.06.12.11.25.16.37 1.08 2.77 2.29 5.66 3.36 8.13 1.63 3.79 2.95 6.62 2.95 6.62z",
    fill: "#ffb0b1"
  }), React.createElement("path", {
    d: "M835.81 260.01a27.6 27.6 0 0 1-18.48 21.16 95.43 95.43 0 0 0-3.06-12.54s18.09-23.38 18.37-18.65c.17 1.8 1.51 5.78 3.17 10.03zM815.55 287.42l2.34-3.29s1.55 9.46 7.26 5.29 6 31.4 6 31.4l-6.14 91.58-44.26-2.65L782 365.5l5-22.27 12.39-32.43 7.42-10.71z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M831.13 321.38l-5.54 82.8-.58 8.77-24.68-1.47-1-.06-18.61-1.11 1.25-44.26 5-22.26 12.39-32.43 7.45-10.72 8.77-12.66 2.34-3.3s1.55 9.47 7.26 5.29l.11-.08c5.57-3.58 5.84 31.49 5.84 31.49z",
    fill: "#1d2366"
  }), React.createElement("path", {
    d: "M787.66 335.99s-2.22 4.64-6.68 3.9-4.45 16.7-4.45 16.7-3 2.78-5 .37-7.42 5.75-7.42 5.75l-33.77 1.49s15 6.86 12.06 27.65c0 0 51-3.16 52.7-8s-7.44-47.86-7.44-47.86z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M787.66 335.99s-2.22 4.64-6.68 3.9-4.45 16.7-4.45 16.7-3 2.78-5 .37-7.42 5.75-7.42 5.75l-33.77 1.49s15 6.86 12.06 27.65c0 0 51-3.16 52.7-8s-7.44-47.86-7.44-47.86z",
    opacity: 0.03
  }), React.createElement("path", {
    fill: "#fff",
    d: "M689.5 375.14l8.91 7.61 73.3 15.4-9.1-9.27-73.11-13.74zM815.68 290.34c-1.21 1.82-4.69 11.38-7.61 19.69-2.42 6.92-4.45 13-4.45 13s-4.73 30.81-7.14 36.37-1.11 27.3-1.11 27.3l-9 53.63s-4.08 27.65-10.38 44.16c-6.18 16.21-13.18 23.84-13.37 24.07 2.79-3.77 18-78.11 18-78.11l5-93.72s.74-8.9 1.49-16.51 15.77-18 15.77-18l14.52-20.65c1.49 2.03.51 5.43-1.72 8.77z"
  }), React.createElement("path", {
    d: "M777.81 410.77s-21.34-.92-31.73-13.36 23.94-5 23.94-5l8.9 2z",
    fill: "#ffb0b1"
  }), React.createElement("path", {
    d: "M877.66 553.1a27 27 0 0 0-.53 12.45c-23.32 1.66-48.27-4.66-48.27-4.66-4.64 4.27-16.89 10.58-16.89 10.58l-6.68-82.77c-4.26-11.14-5.93-69.59-5.93-69.59s.38-3.06 1-7.64c0-.11 0-.23.05-.34 1.67-12.8 5-36.83 6.58-40.08 2.23-4.45-6.86-16.32-6.86-16.32l4.13-35.28.5-4.25c8.73-3.9 15.41-16.33 15.41-16.33l5.12-9c5.59-3.58 5.86 31.49 5.86 31.49l-5.54 82.8 18.49-5.1s36.71 143.46 33.56 154.04z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M901.6 558.85c-25.42 12.62-71.63.93-71.63.93-4.64 4.27-16.89 10.58-16.89 10.58l-6.68-82.77c-4.26-11.13-5.93-69.58-5.93-69.58s5.38-43.61 7.6-48.06c.65-1.3.34-3.23-.43-5.31a67.28 67.28 0 0 1-4.07-31.14l1.78-15.15.5-4.25c8.72-3.9 15.4-16.34 15.4-16.34l4.65-8.14 8.56-15 4.05-7.1.68.62 5.26 4.76s2.23 1.84 5.57 4.67c7.28 6.13 19.86 16.93 26.34 23.53 5.71 5.83 7.51 28.46 8 45.5.35 11.21.14 20 .14 20-5.76 9.46 9.27 85.55 9.27 85.55 3.56 14.66 7.83 106.7 7.83 106.7z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M852.81 297.58s-17.45 33.22-15.4 45.83 7.79 26.91 5 30.25a10.26 10.26 0 0 1-8.17 4.08c-2.78.19-10.21 5.38-10.21 5.94s-6.86.56-13 3.16-15.22 4.08-15.22 4.08-17.63-.56-19.3 1.11-3.34 11.69.19 19.67 7.42 13.92 10.39 15 21.71-5.19 36.92-6.68 31.8-13.51 31.8-13.51 18.18-6.5 21.34-17.45-3.9-71.07-3.9-71.07-5.44-28.02-20.44-20.41z",
    opacity: 0.03
  }), React.createElement("path", {
    d: "M850.57 294.8s-17.44 33.21-15.4 45.83 7.79 26.91 5 30.25a10.26 10.26 0 0 1-8.17 4.08c-2.78.19-10.2 5.38-10.2 5.94s-6.87.55-13 3.15-15.22 4.08-15.22 4.08-17.63-.55-19.3 1.12-3.34 11.69.19 19.67 7.42 13.92 10.39 15 21.71-5.2 36.93-6.68 31.75-13.54 31.75-13.54 18.18-6.49 21.34-17.44-3.9-71.07-3.9-71.07-5.38-28-20.41-20.39z",
    opacity: 0.03
  }), React.createElement("path", {
    d: "M852.24 295.91s-17.43 33.22-15.43 45.79 7.79 26.91 5 30.25a10.23 10.23 0 0 1-8.17 4.08c-2.78.19-10.2 5.38-10.2 5.94s-6.87.56-13 3.16-15.22 4.08-15.22 4.08-17.63-.56-19.3 1.11-3.34 11.69.19 19.67 7.42 13.92 10.39 15 21.71-5.19 36.93-6.68 31.73-13.54 31.73-13.54 18.18-6.5 21.34-17.45-3.9-71.07-3.9-71.07-5.33-27.95-20.36-20.34z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M851.87 384.98s-13.92-2.78-9.09 1.86 4.82 8.72 10.76 8.53-1.67-10.39-1.67-10.39zM875.44 485s-6.31 4.27 5.75 14.1-5.75-14.1-5.75-14.1zM863.37 520.07c0 .56-2.22 20.41 6.13 25.42s-6.13-25.42-6.13-25.42z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M730.88 364.18c-6.72.23-21.27 2.29-13.73 16.35 6.67 12.44 17.87 4.13 24.14-2.19a23.73 23.73 0 0 0-10.41-14.16zM742 377.61zM741.4 378.23c.1-.09.19-.19.28-.28-.09.09-.18.19-.28.28z",
    fill: "#ffb0b1"
  }), React.createElement("path", {
    d: "M850.02 278.12c-7.14 4.88-13.13 9-14.29 9.86-3.21 2.36-9.33 16.28-13.23 23.38-3.14 5.72-13.31 7.19-17.15 7.55l.46-4.21c8.72-3.89 15.4-16.33 15.4-16.33l17.26-30.24 5.94 5.38s2.27 1.79 5.61 4.61z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M850.02 277.57c-7.14 4.87-13.13 9-14.29 9.85-3.21 2.37-9.33 16.28-13.23 23.38-3.14 5.72-13.31 7.19-17.15 7.55l.5-4.25c8.72-3.9 15.4-16.34 15.4-16.34l17.26-30.24 5.94 5.38s2.23 1.8 5.57 4.67z",
    fill: "#dce7ff"
  }), React.createElement("path", {
    d: "M836.28 253.88a26.68 26.68 0 0 1-.61 5.76 27.17 27.17 0 0 1-4.24 9.86 27.56 27.56 0 1 1 4.85-15.62z",
    fill: "#ffb0b1"
  }), React.createElement("path", {
    d: "M884.39 346.6a24.48 24.48 0 0 1-8.89-9.56c-1.55-3.07-2.58-6.6-5.24-8.79-2.38-1.94-5.6-2.42-8.55-3.29-9.77-2.89-18-11.82-18.28-22-.14-4.79 1.35-9.58.67-14.32a15.79 15.79 0 0 0-3.11-7.39 22.89 22.89 0 0 0-2.68-2.89c-1.3-1.23-2.67-2.42-3.85-3.73a14.53 14.53 0 0 1-2-2.65 13.09 13.09 0 0 1-1.07-2.47c-1.82-5.68-.17-12.44-2.21-18.19 0-.1-.07-.21-.11-.31-.78-2.05-2.35-4.09-4.52-4.25s-4.06 1.65-6.14 2.47c-4.36 1.69-9.07-1.19-12.7-4.13s-7.73-6.3-12.36-5.64c-3.05.43-5.47 2.52-8.28 3.6a13.41 13.41 0 0 1-2 .56 27.56 27.56 0 0 1 53.13 10.27 26.68 26.68 0 0 1-.61 5.76c.06.12.11.25.16.37 1.08 2.77 2.29 5.66 3.36 8.13l5.26 4.76s2.23 1.84 5.57 4.67c7.28 6.13 19.86 16.93 26.34 23.53 5.79 5.82 7.59 28.45 8.11 45.49z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M784.81 226.09c1.33-2.71 2-5.74 3.58-8.3 2.33-3.75 6.41-6.1 10.58-7.54 10.92-3.76 34-9.23 40.89 0 1.36 1.83 2.48 3.93 4.36 5.22a33.57 33.57 0 0 0 4.73 2.12c4.4 2.07 7.21 6.56 8.71 11.18s1.94 9.52 3 14.26c1.4 6.06 3.87 11.81 6.32 17.53 2.89 6.75 6 13.74 11.54 18.52 7.61 6.51 9.32 15.72 16.35 22.85 8.37 8.48 8.1 22.47 3.79 33.57a9.25 9.25 0 0 0-1 4.54 8.68 8.68 0 0 0 2.47 4.2l4.57 5.16a25.71 25.71 0 0 1-28.09-13c-1.56-3.07-2.59-6.6-5.25-8.78-2.38-1.95-5.59-2.42-8.55-3.3-9.77-2.89-18-11.82-18.28-22-.14-4.78 1.35-9.58.68-14.32a15.93 15.93 0 0 0-3.1-7.3c-2.57-3.34-6.42-5.61-8.5-9.27-3.52-6.21-.85-14.29-3.39-21-.78-2-2.34-4.09-4.52-4.25s-4.06 1.66-6.14 2.47c-4.36 1.69-9.06-1.19-12.69-4.13s-7.74-6.29-12.36-5.63c-3.06.43-5.47 2.51-8.29 3.59-2.08.8-6.3 1.52-8.13-.24-3.83-3.68 5.08-12.86 6.72-16.15z",
    fill: "#591d4b"
  }), React.createElement("path", {
    d: "M879.21 333.33c-1.55-3.07-2.58-6.6-5.24-8.79-2.38-1.95-5.6-2.42-8.55-3.29-9.77-2.89-18-11.82-18.28-22-.15-4.79 1.35-9.58.67-14.32a15.79 15.79 0 0 0-3.11-7.39c-2.56-3.34-6.42-5.62-8.49-9.28-3.53-6.21-.85-14.29-3.39-21-.78-2-2.34-4.09-4.52-4.25s-4.06 1.65-6.14 2.46c-4.36 1.7-9.07-1.18-12.69-4.12s-7.74-6.29-12.37-5.64c-3 .43-5.46 2.51-8.28 3.6-2.08.8-6.3 1.52-8.13-.24-3.83-3.7 5.08-12.88 6.69-16.16 1.33-2.71 2-5.74 3.58-8.3l.27-.42a14.71 14.71 0 0 0-3 3.48c-1.6 2.56-2.26 5.59-3.58 8.3-1.61 3.29-10.52 12.47-6.69 16.16 1.82 1.76 6 1 8.13.24 2.81-1.08 5.22-3.16 8.28-3.6 4.62-.65 8.73 2.7 12.36 5.64s8.34 5.82 12.69 4.13c2.09-.81 3.91-2.64 6.14-2.47s3.75 2.2 4.53 4.25c2.54 6.67-.14 14.75 3.38 21 2.08 3.65 5.94 5.93 8.5 9.27a15.79 15.79 0 0 1 3.11 7.39c.68 4.74-.82 9.53-.67 14.32.31 10.19 8.51 19.12 18.28 22 2.95.87 6.17 1.34 8.55 3.3 2.66 2.18 3.68 5.71 5.24 8.78a25.71 25.71 0 0 0 28.09 13l-2.15-2.44c-9.44.16-18.93-5.18-23.21-13.61z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M815.13 290.9c-1.22 1.82-4.7 11.38-7.61 19.68-2.72-1.05-5.2-7.81-5.2-7.81l14.49-20.65c1.52 2.04.54 5.44-1.68 8.78z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M815.68 290.34c-1.21 1.82-4.69 11.38-7.61 19.69-2.72-1.05-5.19-7.81-5.19-7.81l14.52-20.65c1.49 2.03.51 5.43-1.72 8.77z",
    fill: "#dce7ff"
  }), React.createElement("path", {
    d: "M731.27 385.3l-8.05-25.35a2.38 2.38 0 0 1 1.54-3 2.36 2.36 0 0 1 3 1.54l8.05 25.37-.8 5.31z",
    fill: "#be8b87"
  }), React.createElement("path", {
    d: "M723.98 357.7a2.38 2.38 0 0 1 3 1.55l8.05 25.35-.61 4 .59.61.8-5.31-8.05-25.35a2.36 2.36 0 0 0-3-1.54 2.32 2.32 0 0 0-1.23.91 2.28 2.28 0 0 1 .45-.22z",
    fill: "#fff",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#efc8c4",
    d: "M731.27 385.3l4.52-1.44-.66 4.36-.14.95-1.32-1.38-2.4-2.49z"
  }), React.createElement("path", {
    d: "M733.67 387.79a1.13 1.13 0 0 1 .29-.24.41.41 0 0 1 .43 0 1 1 0 0 1 .16.25.79.79 0 0 0 .58.39l-.14 1z",
    fill: "#727a9c"
  }), React.createElement("path", {
    d: "M723.18 368.93s16.15-.09 12.34 6.77-9.74 7.7-9.74 7.7z",
    fill: "#ffb0b1"
  }));
};

UndrawScience.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawScience;